import { SvgIcon } from '@mui/material';

const MediumIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3391 21H20.9999V3H16.3391V21ZM14.3295 21H9.6687V9.2184H14.3295V21ZM7.66084 21H3V15.4368H7.66084V21Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default MediumIcon;
